<template>
  <button :type="type" @click="onClick" :disabled="!enabled" :class="{'full-width': fullWidth, cta, 'mob-small': small}">
    <slot>Button</slot>
    <svg class="right" width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="cta">
      <path d="M17 6.51243L10.4596 0L9.23642 1.21797L13.6549 5.64245H0V7.38241H13.6549L9.23642 11.782L10.4596 13L17 6.51243Z" fill="#F5F2F0"></path>
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button'
    },
    cta: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick(e) {
      this.$emit('click', e)
    }
  }
}
</script>


<style lang="scss" scoped>
button {
  background: $button-primary-bg;
  padding: 10px 20px;
  border: none;
  font-family: $secondary-font-family;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-weight: normal;
  color: $button-primary-color;
  line-height: 33px;
  position: relative;
  pointer-events: auto;

  @include mob-small {
    padding: 10px 10px;
    font-size: 15px;
    line-height: 17px;
    letter-spacing: .75px;
  }

  &, * {
    transition: all .1s ease-out;
  }

  &.cta {
    padding-right: 17px + 10px + 4px + 20px;

    @include mob-small {
      padding-right: 17px + 10px + 4px + 10px;
    }
  }

  svg {
    position: absolute;
    top: 10px;
    vertical-align: middle;
    padding: 10px 0;
    height: 33px;

    &.right {
      right: 4px + 20px;
    }
    &.left {
      left: 4px + 20px;
    }
  }

  @include mob-small {
    svg {
      padding: #{(17px - 13px)/2} 0;
      height: 17px;

      &.right {
        right: 4px + 10px;
      }

      &.left {
        left: 4px + 10px;
      }
    }
  }

  &:hover {
    svg.right {
      right: 20px;
    }
    svg.left {
      left: 20px;
    }
  }

  @include mob-small {
    &:hover {
      svg.right {
        right: 10px;
      }
      svg.left {
        left: 10px;
      }
    }
  }
  //&:hover, .active {
  //  color: $button-secondary-active;
  //  svg * {
  //    fill: $button-secondary-active;
  //  }
  //}


  &.full-width {
    width: 100%;
  }

  &[disabled] {
    background-color: rgba($gray-4, 0.5);
    //transition: background-color 0.ms linear;
    pointer-events: none;
  }

  span {
    display: inline-block;
    padding-left: 0.5rem;
  }
}
</style>
